import React, { Fragment, useState, useEffect, useRef } from 'react';

import './CategoryList.scss';
import { link } from '../../helpers/link';
import sendEvent from '../../helpers/tracking';
import { srcSet, useDimensions } from '../../helpers/image';

import ChannelList from '../ChannelList/ChannelList.jsx';

export default function CategoryList(props) {
  const { categories, title, mixed, prefix, eventTrackingCodes } = props;

  return (
    <section id="categoryList">
      <h2>{title}</h2>

      <ul>
        {categories.map((category, idx) => {
          if (idx === 2)
            return mixed ? (
              <Fragment key={idx}>
                <Item category={category} />

                {!!props.channels.length && embedBlock(ChannelList, idx)}
              </Fragment>
            ) : (
              <Item key={idx} category={category} />
            );

          return <Item key={idx} category={category} />;
        })}
      </ul>
    </section>
  );

  function Item({ category }) {
    const ref = useRef();

    const dimensions = useDimensions(ref);

    return (
      <li
        className="categoryList_category"
        onClick={() => eventTrackingCodes && sendEvent(...eventTrackingCodes)}
      >
        <div className="categoryList_overlay"></div>

        {link(
          <Fragment>
            <img
              ref={ref}
              alt="category-image"
              {...(dimensions && {
                srcSet: srcSet(category.imageUrl, dimensions)
              })}
            />

            <div className="categoryList_title">
              <h4>{category.title || category.name}</h4>
            </div>
          </Fragment>,

          prefix ? prefix + category.uri : category.uri
        )}
      </li>
    );
  }

  function embedBlock(Component, idx) {
    return (
      <li key={idx} className="categoryList_embed_block">
        <Component {...props} />
      </li>
    );
  }
}
